/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/forward-10";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Forward10";
export { I as Forward10 };
